import Logger from '../lib/logger';
import CustomBundle from './CustomBundle';
import ConfiguratorSideCart from './ConfiguratorSideCart'
import NumberButton from './NumberButton';
import ConfiguratorModal from './ConfiguratorModal';
import ConfiguratorFilters from './ConfiguratorFilters';

export default function () {
	const NAME = 'ConfigureBundleStep2';
	let customBundle = new CustomBundle();
	const sideCart = new ConfiguratorSideCart(2);
	const intersectional = document.querySelector('configurator-intersectional-observer');
	const filters = document.querySelector('configurator-filters');
	let selectBtns = Array.from(document.querySelectorAll('[data-select-product-btn]'));
	let quantityInputs = Array.from(document.querySelectorAll('[data-update-quantity-input]'));
	const productModal = document.querySelector('configurator-modal[content-type="product"]');
	let productModalLaunchBtns = Array.from(document.querySelectorAll('[data-launch-modal]'));
	let bundleData = customBundle.data;
	sideCart.bundleType = bundleData.type;

	const init = async () => {
		Logger.info(`${NAME} > init`);
		if (window.location.search.startsWith('?rbd=')){
			const rawData = decodeURIComponent(window.location.search.replace(`?rbd=`,''));
			const rawDataString = JSON.stringify(rawData);
			const resp1 = await fetch(window.Shopify.routes.root + 'cart.js');
			const json = await resp1.json();
			const line = json.items.find(line => JSON.stringify(decodeURIComponent(line.properties._raw_bundle_data)) === rawDataString);
			console.log(line);
			if (line) {
				const change = {
					'id': line.key,
					'quantity': 0
				}
				const resp2 = await fetch(window.Shopify.routes.root + 'cart/change.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(change)
				});
				console.log(resp2);
				if (resp2.ok) {
					/* document.dispatchEvent(new Event('cart:build')); */
					sessionStorage.setItem('bundle-data', rawData);
					customBundle = new CustomBundle();
					bundleData = customBundle.data;
					window.history.replaceState(bundleData, '', '/pages/configure-bundle-step-2');
				}
			}
		}
		// redirect to step 1 if no container
		if (!customBundle.hasContainer && !window.parent) {
			window.location.href = '/pages/configure-bundle-step-1';
		}
		//
		if (bundleData.type !== 'custom') {
			// document.querySelector('.configurator-header__back-btn')?.setAttribute('style', 'visibility: hidden');
			document.querySelector('.configurator-header__back-btn')?.setAttribute('href', '#');
			document.querySelector('.configurator-header__back-btn')?.addEventListener('click', (e) => {
				e.preventDefault();
				window.history.back();
			});
			const cartGiftsTitle = document.querySelector('[data-configurator-side-cart] [data-gifts-before-title]');
			cartGiftsTitle.dataset.giftsBeforeTitle = 'Additional ';
			const cartContainerTitle = document.querySelector('[data-configurator-side-cart] [data-container-title]');
			cartContainerTitle.textContent = 'Pre-Designed Gift Basket';
			cartTitle = document.querySelector('[data-configurator-side-cart] .configurator-side-cart__header__title');
			cartTitle.textContent = 'Pre-Designed Gift';
		}
		//
		build();
		addListeners();
	}

	const addListeners = () => {
		selectBtns.forEach((btn) => {
			btn.addEventListener('click', onSelect);
		});
		//
		quantityInputs.forEach((input) => {
			input.addEventListener('input', onUpdateQuantity);
		});
		//
		productModal.addEventListener('modalevent', (e) => {
			if (e.detail.name === 'add') {
				bundleData = customBundle.addGift(e.detail.variantId, 1, e.detail.price, e.detail.title, e.detail.image);
				addGift(bundleData.addedComponentReference.length - 1);
			}
			if (e.detail.name === 'update') {
				onUpdateQuantity({
					target: {
						value: e.detail.quantity,
						dataset: {
							productVariant: e.detail.variantId,
						}
					}
				});
			}
		});
		//
		productModalLaunchBtns.forEach((el) => {
			el.addEventListener('click', openProductModal);
		});
		//
		intersectional.addEventListener('itemsloaded', (e) => {
			filters.dataset.loaded = e.detail.count;
		});
		//
		intersectional.addEventListener('itemsadded', (e) => {
			filters.dataset.count = e.detail.count;

			selectBtns.forEach((btn) => {
				btn.removeEventListener('click', onSelect);
			});
			//
			selectBtns = Array.from(document.querySelectorAll('[data-select-product-btn]'));
			//
			selectBtns.forEach((btn) => {
				btn.addEventListener('click', onSelect);
			});
			//
			quantityInputs.forEach((input) => {
				input.removeEventListener('input', onUpdateQuantity);
			});
			//
			quantityInputs = Array.from(document.querySelectorAll('[data-update-quantity-input]'));
			//
			quantityInputs.forEach((input) => {
				input.addEventListener('input', onUpdateQuantity);
			});
			//
			productModalLaunchBtns.forEach((el) => {
				el.removeEventListener('click', openProductModal);
			});
			//
			productModalLaunchBtns = Array.from(document.querySelectorAll('[data-launch-modal]'));
			//
			productModalLaunchBtns.forEach((el) => {
				el.addEventListener('click', openProductModal);
			});
			//
			const btns = selectBtns.filter((btn) => bundleData.addedComponentReference.includes(btn.dataset.productVariant));
			btns.forEach((btn) => {
				const index = bundleData.addedComponentReference.findIndex((id) => id === btn.dataset.productVariant);
				const quantity = bundleData.addedComponentQuantities[index];
				btn.dataset.selected = 'true';
				btn.parentElement.parentElement.dataset.quantity = quantity;
				//
				if (btn.nextElementSibling.input.value != quantity) {
					btn.nextElementSibling.dataset.value = quantity;
				}
			});
		});
	}

	const build = () => {
		if (customBundle.hasContainer) {
			addContainer();
		}
		//
		if (customBundle.hasGifts) {
			bundleData.addedComponentReference.forEach((r, i) => {
				addGift(i);
			});
		}
		// if card exists in data: add to sideCart
		if (customBundle.hasCard) {
			addCard();
		}
		//
		sideCart.show();
	}

	const openProductModal = (e) => {
		const variantId = e.currentTarget.dataset.productVariant;
		productModal.dataset.productVariantId = variantId;
		const btn = productModal.querySelector('[data-select-product-btn]');
		const index = bundleData.addedComponentReference.findIndex((id) => id === btn.dataset.productVariant);
		if (index > -1) {
			const quantity = bundleData.addedComponentQuantities[index];
			btn.dataset.selected = 'true';
			btn.parentElement.parentElement.dataset.quantity = quantity;
			//
			if (btn.nextElementSibling.input.value != quantity) {
				btn.nextElementSibling.dataset.value = quantity;
			}
		} else {
			btn.dataset.selected = 'false';
		}
		//
		productModal.dataset.show = 'true';
	}

	const onSelect = (e) => {
		Logger.info(`${NAME} > onSelect, ${e.target.dataset.productTitle} ${e.target.dataset.productVariant} ${e.target.dataset.productPrice}`);
		const image = document.querySelector(`#img-${e.target.dataset.productVariant}`)?.src
		bundleData = customBundle.addGift(e.target.dataset.productVariant, 1, e.target.dataset.productPrice, e.target.dataset.productTitle, image);
		addGift(bundleData.addedComponentReference.length - 1);
	}

	const onUpdateQuantity = (e) => {
		Logger.info(`${NAME} > onUpdateQuantity, ${e.target.value}}`);
		const variantId = e.target.dataset.productVariant;
		const value = e.target.value;
		//
		if (value == 0) {
			removeGift(variantId);
		} else {
			bundleData = customBundle.updateGift(variantId, { quantity: value });
			const index = bundleData.addedComponentReference.findIndex((id) => id === variantId);
			sideCart.updateGift(variantId, { quantity: value, price: bundleData.addedComponentPrices[index] * bundleData.addedComponentQuantities[index] });
			sideCart.total = customBundle.getTotal();
			sideCart.count = customBundle.getNumItems();
			const btns = selectBtns.filter((btn) => btn.dataset.productVariant === variantId);
			btns.forEach((btn) => {
				btn.parentElement.parentElement.dataset.quantity = value;
				//
				if (btn.nextElementSibling.input.value != value) {
					btn.nextElementSibling.dataset.value = value;
				}
			});
		}
	}

	const addGift = (index) => {
		const data = {
			variantId: bundleData.addedComponentReference[index],
			quantity: bundleData.addedComponentQuantities[index],
			price: bundleData.addedComponentPrices[index],
			title: bundleData.addedComponentTitles[index],
			icon: 'trash',
			image: bundleData.addedComponentImages[index],
			btnCallBack: removeGiftCB
		}
		//
		sideCart.addItem('gifts', data);
		sideCart.total = customBundle.getTotal();
		sideCart.count = customBundle.getNumItems();
		const btns = selectBtns.filter((btn) => btn.dataset.productVariant === data.variantId);
		btns.forEach((btn) => {
			btn.dataset.selected = 'true';
			btn.parentElement.parentElement.dataset.quantity = data.quantity;
			//
			if (btn.nextElementSibling.input.value != data.quantity) {
				btn.nextElementSibling.dataset.value = data.quantity;
			}
		});

	}

	const addContainer = () => {
		const data = {
			variantId: bundleData.variantId,
			price: bundleData.price * bundleData.quantity,
			quantity: bundleData.quantity,
			title: bundleData.title,
			icon: bundleData.type === 'custom' ? 'edit' : 'none',
			image: bundleData.image,
			extraContent1: bundleData.containerVariantName ? `option: ${bundleData.containerVariantName}` : null,
			extraContent2: bundleData.customText ? `text: ${bundleData.customText}` : null,
			extraContent3: bundleData.customImage ? `image: ${bundleData.customImage}` : null,
			btnCallBack: editContainerCB
		}
		//
		if (sideCart.hasContainer) {
			sideCart.updateContainer(data);
		} else {
			sideCart.addItem('container', data);
		}
		sideCart.total = customBundle.getTotal();
		sideCart.count = customBundle.getNumItems();
	}

	const addCard = () => {
		const data = {
			variantId: bundleData.card.variantId,
			price: bundleData.card.price * bundleData.card.quantity,
			quantity: 1,
			title: bundleData.card.title,
			icon: 'trash',
			image: bundleData.card.image,
			extraContent1: bundleData.card.message ? `message: ${bundleData.card.message}` : null,
			extraContent2: bundleData.card.signature ? `signature: ${bundleData.card.signature}` : null,
			btnCallBack: removeCardCB
		}
		//
		if (sideCart.hasCard) {
			sideCart.updateCard(data);
		} else {
			sideCart.addItem('card', data);
		}
		sideCart.total = customBundle.getTotal();
		sideCart.count = customBundle.getNumItems();
	}

	const removeGift = (variantId) => {
		bundleData = customBundle.updateGift(variantId, { quantity: 0 });
		sideCart.removeGift(variantId);
		sideCart.total = customBundle.getTotal();
		sideCart.count = customBundle.getNumItems();
		const btn = selectBtns.find((btn) => btn.dataset.productVariant === variantId)
		const btns = selectBtns.filter((btn) => btn.dataset.productVariant === variantId);
		btns.forEach((btn) => {
			btn.dataset.selected = 'false';
			btn.parentElement.parentElement.dataset.quantity = 0;
			btn.nextElementSibling.dataset.value = 1;
		});
	}

	const removeGiftCB = (e) => {
		if (e.target.dataset.icon === 'trash') {
			removeGift(e.target.dataset.variantId);
		}
	}

	const removeCardCB = (e) => {
		if (e.target.dataset.icon === 'trash') {
			bundleData = customBundle.updateCard({ quantity: 0 });
			sideCart.removeCard();
			sideCart.total = customBundle.getTotal();
			sideCart.count = customBundle.getNumItems();
		}
	}

	const editContainerCB = (e) => {
		if (e.target.dataset.icon === 'edit') {
			window.location.pathname = '/pages/configure-bundle-step-1';
		}
	}

	init();

}
